<script lang="ts" setup>
import { formatNumber } from '~/utils/localeUtils';
import { DashboardSummaryCardProps } from './_types';
import { DashboardType } from '~/enums/_types';

const props = defineProps<DashboardSummaryCardProps>();

const iconName = computed(() => {
    switch (props.data.Type) {
        case DashboardType.FinishedOrdersYear:
            return 'las la-file-invoice';
        case DashboardType.InvoicesYear:
            return 'las la-highlighter';
        case DashboardType.AllOrdersMonth:
            return 'las la-clock';
        case DashboardType.OpenOrderLinesMonth:
            return 'las la-chart-line';
    }
});

const iconColors = computed(() => {
    switch (props.data.Type) {
        case DashboardType.FinishedOrdersYear:
            return { color: 'on-primary', bg: 'primary' };
        case DashboardType.InvoicesYear:
            return { color: 'on-primary', bg: 'positive' };
        case DashboardType.AllOrdersMonth:
            return { color: 'on-primary', bg: 'warning' };
        case DashboardType.OpenOrderLinesMonth:
            return { color: 'primary', bg: 'secondary' };
    }
});
</script>
<template>
    <q-card
        class="column cursor-pointer dashboard-number-block"
        :class="[isActive ? 'dashboard-number-block__active' : '']"
        square
        bordered
    >
        <q-card-section class="row items-center justify-between no-wrap q-pb-sm a-text-16 text-on-background-1">
            <span class="inline-block">{{ $t(`enums.dashboard_types.${data.Type}`) }}</span>
            <q-icon
                :name="iconName"
                size="sm"
                :color="iconColors.color"
                class="q-pa-sm"
                :class="`bg-${iconColors.bg}`"
            />
        </q-card-section>
        <q-card-section class="col-grow column justify-end q-py-none a-text-28 text-bold">
            {{ formatNumber(data.Summary.CurrentCount) }}
        </q-card-section>
        <q-card-section class="row q-pt-none items-center a-text-15">
            <div class="text-on-background-1">
                {{
                    data.Type === DashboardType.AllOrdersMonth || data.Type === DashboardType.OpenOrderLinesMonth
                        ? $t('dashboard.current-month')
                        : $t('dashboard.current-year')
                }}
            </div>
        </q-card-section>
    </q-card>
</template>
